import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f72f19a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = ["aria-selected"]
const _hoisted_3 = { class: "contact-footer-accordion__title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "plus-minus" }, null, -1))
const _hoisted_5 = {
  role: "tabpanel",
  class: "contact-footer-accordion__content"
}
const _hoisted_6 = { class: "contact-footer-accordion__content-inner" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.id,
    class: _normalizeClass(["contact-footer-accordion__tab", { 'contact-footer-accordion__tab--open': _ctx.isOpen }])
  }, [
    _createElementVNode("button", {
      class: "contact-footer-accordion__button",
      "aria-selected": _ctx.isOpen,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clickTab', $event))),
      type: "button",
      role: "tab"
    }, [
      _createElementVNode("span", _hoisted_3, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.title), 1)
      ]),
      _hoisted_4
    ], 8, _hoisted_2),
    _createVNode(_Transition, { name: "expand" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ])
        ], 512), [
          [_vShow, _ctx.isOpen]
        ])
      ]),
      _: 3
    })
  ], 10, _hoisted_1))
}